<template>
	<v-container fluid>
		<v-row class="mb-3">
			<v-col cols="7" md="8" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87">mdi-account-multiple</v-icon>
					<p class="text-lg-h5 font-weight-600">{{ $t('customer_list') }}</p>
				</div>
			</v-col>

			<v-col cols="5" md="4" class="d-flex align-center justify-end">
				<v-text-field v-if="!isSmallScreen" variant="plain" density="compact" hide-details
					class="box-shadow isRounded pb-1 pl-1" :placeholder="$t('search')" style="
						border: 1px solid rgba(181, 183, 192, 1);
						background-color: rgba(255, 255, 255, 1);
						border-radius: 16px;
						padding: 8px, 16px, 8px, 16px;
					"><template v-slot:prepend>
						<div>
							<v-icon style="color: rgba(0, 0, 0, 1); font-size: 30px" class="ml-2"
								@click="searchAgent">mdi-magnify</v-icon>
						</div>
					</template></v-text-field>
			</v-col>
		</v-row>

		<v-card v-if="isFetchingIncidents" height="400px" class="d-flex" align="center">
			<v-card-text class="text-center my-auto">
				<v-progress-circular color="grey" :size="80" indeterminate class="mb-4 mx-auto" />
				<div>Generating Report...</div>
			</v-card-text>
		</v-card>

		<v-card v-else>
			<v-card-text>
				<div class="dashboard">
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						@openCustomerEditor="openEditCustomerDialog" @openDeleteCustomer="openDeleteCustomerDialog"
						@singleCustomerInformation="getSingleCustomerInfo" />
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="showEditCustomeProfile" width="auto">
			<edit-customer @closeDialog="showEditCustomeProfile = false" :customer-detail="customerDetail"
				@emit-update-customer-profile="updateCustomerProfile">
			</edit-customer>
		</v-dialog>
		<v-dialog v-model="showDeleteCustomer" width="auto">
			<v-card rounded="xl">
				<v-card-title>
					<div class="ma-4">
						Do you want to delete customer
						<strong style="color: rgba(255, 126, 135, 1)">"{{ this.customerToDelete }}"</strong>
						?
					</div>
				</v-card-title>
				<v-card-footer>
					<div class="bg-black">
						<div class="d-flex justify-space-between pa-2">
							<v-btn variant="text" text @click="showDeleteCustomer = false"
								class="text-none">Cancel</v-btn>
							<v-btn variant="text" text @click="confirmDelete(this.customerToDeleteId)">
								<div class="d-flex align-center text-none">
									<div class="mr-2">Confirm</div>
									<div>
										<v-icon size="x-large">mdi-arrow-right-thin-circle-outline</v-icon>
									</div>
								</div>
							</v-btn>
						</div>
					</div>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Profile has been saved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
		<v-snackbar v-model="deleteSnackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Customer has been deleted .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="deleteSnackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import EditCustomerProfile from '@/components/EditCustomerProfile.vue'
import CustomerListDataTable from '@/components/CustomerListDataTable.vue'
import customerInfo from '@/services/API/customerInfo.js'

export default {
	components: {
		'data-table': CustomerListDataTable,
		'edit-customer': EditCustomerProfile,
	},
	data: () => ({
		showEditCustomeProfile: false,
		items: [],
		showDeleteCustomer: false,
		customerToDelete: null,
		customerToDeleteId: null,
		snackbar: false,
		deleteSnackbar: false,
		customerDetail: {},
		headers: [
			{
				text: 'Name',
				value: 'customerName',
				width: '15%',
			},
			{
				text: 'Email',
				value: 'CustomerEmail',
				width: '25%',
			},
			{
				text: 'Contact',
				value: 'customerPhone',
				width: '35%',
			},
			{
				text: 'Incident History',
				value: 'incidentCount',
				sortable: true,
			},
			{
				text: '',
				value: 'button',
				width: '25%',
			},
		],
	}),
	created() {
		this.getCustomerInfo()
	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Name', 'Email', ''].includes(item.text)
			)
		},
	},

	methods: {
		async updateCustomerProfile(updateObj) {
			let customerDetail = updateObj.customerDetail
			await customerInfo
				.updateCustomerProfile(
					updateObj.id,
					customerDetail /** send the payload */,
					updateObj.pictureUrl
				)
				.then(() => {
					this.snackbar = true
					setTimeout(() => {
						location.reload()
					}, 1000)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		async getCustomerInfo() {
			await customerInfo.listCustomerInformation().then((response) => {
				if (response.status == 200) {
					this.items = response.data.data
				}
			})
		},
		async getSingleCustomerInfo(id) {
			this.$router.push(
				`customer-list/customer-information?customerId=${id}`
			)
		},
		async openEditCustomerDialog(id) {
			// await this.getAgentDetials(id)
			await customerInfo
				.getSingleCustomerInformation(id)
				.then((response) => {
					if (response.status == 200) {
						this.customerDetail = response.data.data
					}
				})
				.finally(() => {
					this.showEditCustomeProfile = true
				})
		},
		async openDeleteCustomerDialog(data) {
			this.showDeleteCustomer = true
			this.customerToDelete = data.name
			this.customerToDeleteId = data.id
		},
		async confirmDelete(id) {
			await customerInfo.deleteCustomer(id).then(() => {
				this.showDeleteCustomer = false
				this.deleteSnackbar = true
				this.getCustomerInfo()
			})
		},
		singleCustomerList() {
			this.customerDetail = response.data
		},
		closeDialog() {
			this.$emit('closeDialog')
		},
		customerInfo(id) {
			this.$router.push(
				`customer-list/customer-information?customerId=${id}`
			)
		},
	},
}
</script>
<style scoped>
.box-shadow {
	box-shadow: 0px 0px 20px 0px rgba(131, 133, 143, 0.2) !important;
}
</style>
